(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("i18n/el", [], factory);
	else if(typeof exports === 'object')
		exports["i18n/el"] = factory();
	else
		root["i18n/el"] = factory();
})(window, function() {
return 